import apiService from '../apiService'
export const countryController = configService => {
  const service = apiService(configService)
  return {
    getListCountry: () => {
      return service.get({
        url: 'cms/country',
      })
    },
  }
}
